<template>
  <div class="recoMain">
    <div v-if="noStartOrEnd" class="emptyActiveContainer">
      <div class="emptyTitle">{{ noStartOrEnd }}</div>
      <div class="subEmptyTitle">看看其他活动吧</div>
      <div class="emptyIcon"></div>
    </div>
    <BetterScroll :data="nowShowList" @scrollToEnd="loadData" v-else>
      <div class="con">
        <div class="topPanel" v-if="shareParameter.share_banner_web">
          <img class="top_bar" :src="shareParameter.share_banner_web" alt="" />
          <div class="msgPanel">
            <div class="msgList">
              <img
                v-if="
                  share_content_text && share_content_text.indexOf('<a') > -1
                "
                src="@/assets/images/position/icon_point.png"
                alt=""
              />
              <!-- <p>禾蛙宣讲会, 职位多多机会多多, 快来看吧!!!</p> -->
              <div class="links" v-html="share_content_text"></div>
            </div>
          </div>
        </div>
        <div class="card_lists">
          <div
            v-for="(jobInfo, i) in nowShowList"
            :key="jobInfo.job_id + 's' + i"
          >
            <div class="card" @click="handleDetail(jobInfo.job_id)">
              <div class="left" style="width: 75%">
                <div
                  :class="
                    jobInfo.job_open_status === 20 ? 'title-grey' : 'title'
                  "
                >
                  <div class="jobInfoItems">
                    <div class="item">
                      <span style="margin-right: 10px">
                        {{
                          jobInfo.job_name.length > 26
                            ? jobInfo.job_name.substr(0, 26) + '...'
                            : jobInfo.job_name
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="label">
                  <!-- <span class="label_item">{{ jobInfo.work_city }}</span>
               -->
                  <CityListPanel :cityList="setCityList(jobInfo)" />
                  <span class="label_item">{{ jobInfo.education }}</span>
                  <span class="label_item">{{
                    utils.dicWorkYears(jobInfo.work_years).label
                  }}</span>
                  <!-- <span class="label_item">{{ jobInfo.head_count + "人" }}</span> -->
                  <span class="label_item"
                    >{{
                      jobInfo.hc_amount ||
                      jobInfo.head_count ||
                      jobInfo.head_count_sum
                    }}人</span
                  >
                </div>
                <p
                  class="desc"
                  :class="jobInfo.job_open_status === 20 ? 'desc_grey' : 'desc'"
                  :style="
                    loginInfo && isMember
                      ? 'color: #4F4F4F;'
                      : `color: transparent;text-shadow: 0 0 10px rgba(0,0,0,0.5);-webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;`
                  "
                  @click.stop="handleBindHint"
                >
                  {{
                    jobInfo.is_anonymous
                      ? jobInfo.anonymous_company_name
                      : jobInfo.customer_company_name
                  }}
                </p>
              </div>
              <div class="right">
                <p
                  :class="
                    jobInfo.job_open_status === 20 ? 'amount_close' : 'amount'
                  "
                >
                  {{ jobInfo.salary }}
                </p>
                <div
                  :class="
                    collectMap[jobInfo.job_id] == '1' ||
                    (jobInfo.is_collected == 1 && !collectMap[jobInfo.job_id])
                      ? 'collected'
                      : 'uncollect'
                  "
                  @click.stop="handleCollection(jobInfo)"
                />
                <p class="status">
                  {{ jobInfo.job_open_status === 20 ? '职位已关闭' : '' }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 骨架 -->
        <div class="con" v-if="isFirst">
          <div class="card_con">
            <div v-for="(item, i) in [1, 2, 3, 4, 5]" :key="i">
              <img
                src="@/assets/images/position/card-position-loading.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 加载动画 -->
        <div class="loading_co" v-show="!isFirst && isShowLoading">
          <div>
            <van-loading color="#1989fa" />
          </div>
        </div>
        <div v-if="!historyFlag && haveMore" class="more_desc gray">
          更多小蛙推荐职位
        </div>
        <!-- <div
      v-if="haveMore"
      @click="loadMore"
      class="more_desc"
      :style="loginInfo ? '' : 'margin-bottom:50px'"
    >
      点击加载更多
    </div> -->
        <div
          v-if="!haveMore"
          class="bot_btn"
          :style="loginInfo ? '' : 'margin-bottom:50px'"
        >
          <!-- 没有更多职位了哦~ -->
          <button @click="gotoMain" type="button" class="searchBtn">
            查看更多
          </button>
        </div>
      </div>
    </BetterScroll>
    <!-- <div v-if="!loginInfo" class="login_card">
      <p class="login_desc">登录禾蛙解锁更多信息</p>
      <div class="login_btn" @click="handleLogin">登录/注册</div>
    </div> -->

    <LoginDialog
      v-if="popupVisible"
      :visible="popupVisible"
      @loginResult="loginResult"
    />
  </div>
</template>

<script>
import LoginDialog from '@/components/dialogs/LoginDialog'

import utils from '../../utils/utils'
import { mapState, mapMutations, mapActions } from 'vuex'
import CityListPanel from '@/components/CityListPanel'
import Cookies from 'js-cookie'

import BetterScroll from '@/components/BetterScrollCom'
export default {
  name: 'index',
  components: {
    LoginDialog,

    CityListPanel,
    BetterScroll,
  },
  data() {
    return {
      code: '',
      popupVisible: false,
      hintVisible: false,
      utils: utils,
      type: '',
      nowShowList: [],
      collectMap: {},
      pageNum: 1,
      pageSize: 10,
      pageNum1: 1,
      pageSize1: 10,
      loading: false,
      historyFlag: false,
      requestData: false,
      share_content_text: '',
      isFirst: true,
      isShowLoading: false,
    }
  },
  computed: {
    ...mapState('index', [
      'loginInfo',
      'authInfo',
      'nowJobList',
      'nowJobListCount',
      'historyJobList',
      'historyJobListCount',
      'shareParameter',
      'share_content',
      'noStartOrEnd',
    ]),
    isMember() {
      return this.authInfo ? parseInt(this.authInfo.user_type) > 3 : false
    },
    haveMore() {
      if (this.nowShowList.length == 0) {
        return true
      }
      if (this.nowJobListCount > this.nowShowList.length) {
        return true
      } else if (this.loginInfo && this.type === 'recommend') {
        if (!this.historyFlag) {
          return true
        } else if (
          this.nowJobListCount + this.historyJobListCount >
          this.nowShowList.length
        ) {
          return true
        }
      } else {
        return false
      }
      return false
    },
  },
  watch: {
    loginInfo: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.queryNowJobList()
          this.requestAuth()
        }
        return newValue
      },
      // immediate: true,
    },
    nowJobList(newValue, oldValue) {
      if (newValue) {
        this.pageNum++
        if (this.isFirst) {
          this.isFirst = !this.isFirst
        }
        this.isShowLoading = false
        this.nowShowList = this.nowShowList.concat(newValue)
      }
      return newValue
    },
    historyJobList(newValue, oldValue) {
      if (newValue) {
        this.pageNum1++
        if (this.isFirst) {
          this.isFirst = !this.isFirst
        }
        this.isShowLoading = false
        this.nowShowList = this.nowShowList.concat(newValue)
      }
      return newValue
    },
    nowShowList(value) {
      this.requestData = true
    },
    share_content(val) {
      let list = val.split('')
      let number = 0
      list.map((item, index) => {
        if (item == '%') {
          number++
          if (number % 2 == 0) {
            list[index] = list[index].replace('%', '</i>')
          } else {
            list[index] = list[index].replace('%', '<i>')
          }
        }
      })
      this.share_content_text = list.toString().replace(/,/g, '')
    },
  },
  created() {
    let LoginStatus = this.getLoginStatus()
    if (LoginStatus) {
      this.popupVisible = true
    }
  },
  mounted() {
    let code = this.getUrlParam('codes')
    if (code) {
      this.code = code
    }
    let type = this.getUrlParam('type')
    if (type) {
      this.type = type
    }

    if (document.body.clientWidth > 750) {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `https://h5-test2.hewa.cn/recommend.html?codes=${this.code}&type=${this.type}#/`
      } else {
        window.location.href = `http://hewa.cn/recommend.html?codes=${this.code}&type=${this.type}#/`
      }
    }

    let loginInfo = Cookies.get('loginInfo')
    let authInfo = Cookies.get('authInfo')

    if (loginInfo) {
      this.setStateItem({
        key: 'loginInfo',
        value: JSON.parse(loginInfo),
      })
    } else {
      this.queryNowJobList()
    }
    if (authInfo) {
      this.setStateItem({
        key: 'authInfo',
        value: JSON.parse(authInfo),
      })
    }
  },
  methods: {
    ...mapActions('index', [
      'requestAuth',
      'requestNowJobList',
      'requestShareJobList',
      'requestHistoryJobList',
      'requestCollectJob',
      'requireJobShareParameter',
    ]),
    ...mapMutations('index', ['setStateItem']),
    getUrlParam(name) {
      //构造一个含有目标参数的正则表达式对象
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      //匹配目标参数
      var r = window.location.search.substr(1).match(reg)
      //返回参数
      if (r != null) {
        return unescape(r[2])
      } else {
        return null
      }
    },
    loadMore() {
      if (this.haveMore) {
        this.isShowLoading = true
        if (this.nowShowList.length < this.nowJobListCount) {
          this.queryNowJobList()
        } else {
          this.queryHistoryJobList()
        }
      }
    },
    handleLogin() {
      this.popupVisible = true
    },
    handleDetail(job_id) {
      //   if (this.code) {
      //     Cookies.set('recommendCode', JSON.stringify(this.code))
      //   }
      let currentUrl = [window.location.pathname, window.location.search] // 记录localstage
      localStorage.setItem('sourceUrl', encodeURIComponent(currentUrl.join('')))
      let loginInfo = Cookies.get('loginInfo')
      if (loginInfo) {
        this.$router.push({
          name: 'positionDetail',
          query: {
            job_id: job_id,
            codes: this.$route.query.codes,
            jobType: 4,
          },
        })
      } else {
        this.popupVisible = true
      }
    },
    handleCollection(jobInfo) {
      if (this.loginInfo) {
        let status = ''
        if (this.collectMap[jobInfo.job_id] == '1') {
          this.$set(this.collectMap, jobInfo.job_id, '2')
          status = '1'
        } else if (this.collectMap[jobInfo.job_id] == '2') {
          this.$set(this.collectMap, jobInfo.job_id, '1')
          status = '0'
        } else {
          if (jobInfo.is_collected == 0) {
            this.$set(this.collectMap, jobInfo.job_id, '1')
            status = '0'
          } else {
            this.$set(this.collectMap, jobInfo.job_id, '2')
            status = '1'
          }
        }

        this.requestCollectJob({
          data_id: jobInfo.job_id,
          data_status: status, //0收藏 1取消收藏
          cb: () => {},
        })
      } else {
        this.handleLogin()
      }
    },
    queryNowJobList() {
      this.requestShareJobList({
        code: this.code,
        id: '',
        page: this.pageNum,
        limit: this.pageSize,
        source: 1,
      })
      this.requireJobShareParameter({ code: this.code })
    },
    queryHistoryJobList() {
      this.historyFlag = true
      this.requestHistoryJobList({
        page: this.pageNum1,
        limit: this.pageSize1,
      })
    },
    loginResult(result) {
      this.popupVisible = false
    },
    handleBindHint() {
      if (this.loginInfo) {
        if (!this.isMember) {
          this.hintVisible = true
        }
      } else {
        this.popupVisible = true
      }
    },
    hintResult(result) {
      this.hintVisible = false
    },
    loadData() {
      if (this.requestData) {
        if (!this.isMember && this.loginInfo) {
          this.hintVisible = true
          return
        } else if (!this.loginInfo) {
          this.popupVisible = true
          return
        }
        this.loadMore()
        this.requestData = false
      }
    },
    setCityList(data) {
      let arr = []
      if (data.city_list) {
        data.city_list.forEach((item, i) => {
          arr[i] = { name: '', count: 0 }
          arr[i].name = item
        })
      }
      return arr
    },
    gotoMain() {
      this.$router.push({ path: '/main/position' })
    },
  },
  beforeDestroy() {
    this.setStateItem({
      key: 'share_content',
      value: '',
    })
  },
}
</script>
<style scoped lang="scss">
.emptyActiveContainer {
  text-align: center;
  padding-top: 100px;
  .emptyTitle {
    font-size: 21px;
    color: #000;
    font-weight: 500;
  }
  .subEmptyTitle {
    margin-top: 9px;
    color: #6b778e;
    font-size: 14px;
  }
  .emptyIcon {
    margin-top: 24px;
    height: 140px;
    background: url('../../assets/images/position/end.png') center center
      no-repeat;
    background-size: auto 100%;
  }
}

.recoMain {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #fbfbfb;
}
p {
  margin: 0;
}
/* .page {
  flex: 1;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  background-color: #f6f6f6;
  position: relative;
  padding: 0 0 150px;
  height: 100%;
  overflow: auto;
  zoom: 1;
} */

.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  background: #ffffff;
  margin-bottom: 10px;
  padding: 14px 24px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: flex-start;
}
.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
  margin-bottom: 12px;
  word-wrap: break-word;
  width: 100%;
}
.title-grey {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 12px;
  word-wrap: break-word;
  width: 100%;
}
.label {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 12px;
  display: flex;
}
.label_item {
  margin-right: 10px;
}
.desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
}
.desc_grey {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
}
.amount {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #5ebfb9;
  margin-bottom: 12px;
}
.amount_close {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 12px;
}
.status {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #909090;
}
.login_card {
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 21px 40px 45px;
  background-color: white;
  box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0px 0px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  z-index: 300;
}
.login_desc {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5d5d5d;
  text-align: center;
}
.login_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5ebfb9;

  color: white;
  height: 50px;
  border: none;
  border-radius: 5px;
  margin: 0.61rem 0 0.29rem;

  font-size: 18px;
  font-weight: 500;
  width: 100%;
}
.uncollect {
  width: 24px;
  height: 24px;
  background: url('../../assets/images/collect_un.png') no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 12px;
}
.collected {
  width: 24px;
  height: 24px;
  background: url('../../assets/images/collect_had.png') no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 12px;
}
.history_title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909090;
  text-align: center;
  margin-bottom: 20px;
}
.more_desc {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;

  // color: $color_a;
}
.gray {
  color: rgba(0, 0, 0, 0.4);
}
.top_bar {
  width: 100% !important;
}
.wrap {
  /* height: 100%; */
  flex: 1;
  overflow: hidden;
}
.msgPanel {
  height: 70px;
  width: 100%;
  background: white;
  position: relative;
  .msgList {
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px #eee;
    position: absolute;
    left: 0;
    right: 0;
    /* transform: translateX(-50%); */
    transform: translateY(-50%);
    margin: auto;
    padding: 18px 20px;
    width: 328px;
    box-sizing: border-box;
    p {
      color: #4f4f4f;
      font-family: PingFang SC;
      font-weight: regular;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0px;
      text-align: left;
    }
    img {
      width: 58px;
      position: absolute;
      right: 10px;
      bottom: -20px;
    }
  }
}
.links {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  margin-top: 4px;
  text-align: left;
  color: #4f4f4f;
  font-style: normal;
}
::v-deep {
  a {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: left;
    color: #53bdb3;
  }
  i {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: left;
    color: #53bdb3;
    font-style: normal;
  }
}
.searchBtn {
  border-radius: 0.213333rem;
  background: linear-gradient(140.98deg, #5bcec7 0%, #51c0f0 100%);
  border: 0;
  width: 88%;
  margin: 10px auto;
  display: block;
  height: 36px;
  line-height: 36px;
  color: #fff;
  font-size: 14px;
}
.bot_btn {
  width: 100%;
  padding: 10px 0;
}
.card_con {
  img {
    width: 100%;
  }
}
.loading_co {
  display: flex;
  align-items: center;
  justify-content: center;
}
.jobInfoItems {
  .subsidyItem {
    font-size: 11px;
    border-radius: 4px;
    background-color: #ffeeee;
    color: #ff6f53;
    padding: 2px 5px;

    font-weight: normal;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
  .upIcon {
    background: url('../../assets/images/main/up.png') center center no-repeat;
    background-size: 12px auto;
    width: 12px;
    height: 18px;
    display: inline-block;
    vertical-align: bottom;
    margin-right: 3px;
  }
}
</style>
